import { SmallScreen } from "Core/Responsive";
import { observer } from "mobx-react";
import React, { useCallback } from "react";
import { useSmallScreen } from "Shared/Hooks";
import { Paths } from "Shared/Utils";

import { mergeClasses, useRestoreFocusTarget } from "@fluentui/react-components";
import { useBoolean } from "Shared/Hooks/Util";
import { LineHorizontal3Regular } from "@fluentui/react-icons";

import { AppLeftBarFlyout } from "../AppLeftBar/AppLeftBarFlyout";
import { useStyles } from "./AppHeader.styles";
import { useShowHeader } from "Shared/Utils/useShowHeader";

const AppHeaderBase = () => {
    const isSmallScreen = useSmallScreen();
    const classNames = useStyles();
    const showHeader = useShowHeader();
    const restoreFocusTargetAttribute = useRestoreFocusTarget();

    const [isLeftBarOpen, { setTrue: openLeftBar, setFalse: dismissLeftBar }] = useBoolean(false);

    const onKeyDownToOpenLeftBar = useCallback(
        (e: React.KeyboardEvent) => {
            if (e.key === " " || e.key === "Enter") {
                openLeftBar();
            }
        },
        [openLeftBar]
    );

    const leftIconContainerSmallscreen = mergeClasses(classNames.leftIconContainer, classNames.leftIconContainerInSmallScreen);

    return (
        <div className={classNames.headerConatiner}>
            <SmallScreen>
                <div
                    {...restoreFocusTargetAttribute}
                    className={leftIconContainerSmallscreen}
                    onClick={openLeftBar}
                    role="button"
                    tabIndex={0}
                    onKeyDown={onKeyDownToOpenLeftBar}
                    title="open left bar"
                    aria-label="open left bar"
                >
                    <LineHorizontal3Regular className={classNames.leftIcon} />
                </div>
                <AppLeftBarFlyout isOpen={isLeftBarOpen} onRequestClose={dismissLeftBar} />
            </SmallScreen>
            <img
                src={Paths.getStaticFullPath("images/logo/osplogo-left.png")}
                role="presentation"
                width="32"
                height="32"
                alt=""
                className={isSmallScreen ? "" : classNames.largeScreenLogoMargin}
            />
            {showHeader && <div className={classNames.appMenuHeader}>M365 Pulse</div>}
        </div>
    );
};

export const AppHeader = observer(AppHeaderBase);
